<h4 mat-dialog-title style="margin-left: 20px; font-weight: bolder">{{ this.translationService.translate('unlockAccountText') }}</h4>
<mat-dialog-content class="mat-typography">
  <p>
    {{ this.translationService.translate('unlockConfirmationText') }} <b>{{ loginName }}</b
    >? <br />
    {{ this.translationService.translate('unlockConfirmRemainText') }} <br />
    {{ this.translationService.translate('unlockResetPasswordConfirmText')
    }}<b> {{ this.translationService.translate('resetPasswordText') }}</b> {{ this.translationService.translate('optionText') }}.
  </p>
</mat-dialog-content>

<mat-dialog-actions align="end" style="margin-bottom: 15px">
  <div>
    <button mat-flat-button (click)="cancelUnlockAccount()">{{ this.translationService.translate('cancelLinkText') }}</button>
    <button mat-flat-button color="primary" (click)="confirmResetPassword()">
      {{ this.translationService.translate('resetPasswordText') }}
    </button>
    <button mat-flat-button color="primary" (click)="unlockUserAccount()">
      {{ this.translationService.translate('unlockAccountText') }}
    </button>
  </div>
</mat-dialog-actions>

<mic-modal class="modalC" #resetPasswordModal (result)="onResetPasswordModalClosed($event)"></mic-modal>
<ng-template #resetPasswordConfirmation>
  <p [innerHTML]="resetPasswordText"></p>
</ng-template>
